<div class="h-100 overflow-auto">
    <div class="container-sm-fluid pt-3 px-sm-4">
        @if (tabs.length > 1) {
            <dx-tabs
                keyExpr="key"
                [items]="tabs"
                [selectedItemKeys]="[selectedTab]"
                [showNavButtons]="false"
                stylingMode="primary"
                class="mb-2"
                (onItemClick)="selectedTab = $event.itemData.key"></dx-tabs>
        }
    </div>

    @if (selectedTab === 'appointmentAging' && showAppointmentAging) {
        <app-appointment-aging-score></app-appointment-aging-score>
    } @else if (selectedTab === 'inboundProductivity' && showInboundProductivity) {
        <app-inbound-productivity-score></app-inbound-productivity-score>
    } @else if (selectedTab === 'tagsRequired' && showTagsRequired) {
        <app-tags-required-score></app-tags-required-score>
    } @else if (selectedTab === 'appointmentCompliance' && showAppointmentCompliance) {
        <app-appointment-compliance-score></app-appointment-compliance-score>
    }
</div>